import { render } from "./WalletTransfersTab.vue?vue&type=template&id=71a156b0&scoped=true"
import script from "./WalletTransfersTab.vue?vue&type=script&lang=js"
export * from "./WalletTransfersTab.vue?vue&type=script&lang=js"

import "./WalletTransfersTab.vue?vue&type=style&index=0&id=71a156b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a156b0"]])

export default __exports__